import { Button, ButtonProps } from '@mui/material';
import React from 'react';
import { sxButton } from './sxProps';

interface Props extends ButtonProps {
}

const DefaultButton: React.FC<Props> = ({ children, onClick, disabled, ...props }) => {

    return (
        <Button
            disabled={disabled}
            onClick={onClick}
            sx={sxButton}
            variant='contained'
            {...props}
        >
            {children}
        </Button>
    )
}

export default DefaultButton;